import { ISearchFiltersResponse } from 'src/interfaces/next-api/search-filters';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import { useSiteContext } from 'src/store';

const useSearchFilters = (containerId?: string) => {
  const router = useRouter();
  const { tenantId, packageId, appContainerId, includeAllCommissionableApps } =
    useSiteContext();
  const fetcher = (url: string) => fetch(url).then((res) => res.json());
  const { locale } = router;
  const isLocaleDefault = locale === '__default';
  const localeQuery =
    locale && !isLocaleDefault ? `&locale=${router.locale}` : '';
  const apiUrl = `/api/search-filters?tenantId=${tenantId}&packageId=${packageId}&containerId=${
    containerId || appContainerId
  }&includeAllCommissionableApps=${includeAllCommissionableApps}${localeQuery}`;
  const shouldFetch = tenantId && packageId;

  const { data: searchFiltersResponse, isLoading } =
    useSWR<ISearchFiltersResponse>(shouldFetch ? apiUrl : null, fetcher, {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    });

  return {
    filters: searchFiltersResponse?.searchFilters,
    isLoading,
  };
};

export default useSearchFilters;
